import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { DataFormComponent } from '@shared/components/data-form/data-form.component';
import { DataFormEvent } from '@shared/components/data-form/data-form.model';
import { FormDrawerRequest } from '@shared/components/page-layout/drawers/form-drawer/form-drawer.type';
import { LayoutDrawerComponent } from '@shared/components/page-layout/drawers/layout-drawer.component';
import { PageLayoutService } from '@shared/components/page-layout/page-layout.service';
import { AlertService } from '@shared/services/alert.service';

@Component({
    selector: 'app-form-drawer',
    templateUrl: './form-drawer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DataFormComponent]
})
export class FormDrawerComponent extends LayoutDrawerComponent implements OnInit {
  protected layoutService: PageLayoutService;
  private alertService = inject(AlertService);

  formConfig: FormDrawerRequest;

  constructor() {
    const layoutService = inject(PageLayoutService);
    super();
  
    this.layoutService = layoutService;
  }
  ngOnInit(): void {
    this.formConfig = this.drawer.data as FormDrawerRequest;
  }


  onSubmitForm(event: DataFormEvent) {
    this.layoutService.setParentDrawerSubject(event);
    if (event.keepOpenWithoutReset) return;
    if (event.keepOpen) {
      this.alertService.successToast('Success', 'Successfully saved');
      return;
    }
    this.layout.closeParentDrawer();
  }

  onCancelForm() {
    this.layout.closeParentDrawer();
  }
}
